// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';

// eslint-disable-next-line no-unused-vars
new Swiper( '.testimonials', {
	// configure Swiper to use modules.
	modules: [ Navigation ],
	// Default parameters.
	slidesPerView: 1.2,
	speed: 400,
	loop: true,
	spaceBetween: 24,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	// Responsive breakpoints.
	breakpoints: {
		// when window width is >= 480px.
		480: {
			slidesPerView: 2,
			spaceBetween: 24,
		},
		// when window width is >= 1280px.
		1280: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
	},
	on: {
		// eslint-disable-next-line object-shorthand
		init: function () {
			const cards = document.querySelectorAll( '.swiper-wrapper .testimonial-card' );
			let maxHeight = 0;

			cards.forEach( ( card ) => {
				const cardHeight = card.offsetHeight;
				if ( cardHeight > maxHeight ) {
					maxHeight = cardHeight;
				}
			} );

			cards.forEach( ( card ) => {
				card.style.minHeight = `${ maxHeight }px`;
			} );
		},
	},
} );
